import React from "react";
import ImgHeader from "../ImgHeader";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import { H1, H2 } from "../Headers";
import WithHelperBar from "../WithHelperBar";
import Steps from "./Steps";
import PartnershipTiersCard from "../cards/PartnershipTiersCard";
import PartnershipBrandingCard from "../cards/PartnershipBrandingCard";
import { Grid } from "@material-ui/core";
import getUrl from "../../functions/getUrl";
import fromMarkdown from "../../functions/fromMarkdown";
import MyIntegrationsCard from "../cards/MyIntegrationsCard";
import IntegrationDefinitionCard from "../cards/IntegrationDefinitionCard";
import ECommerceDocumentCard from "../cards/ECommerceDocumentCard";

export default () => {
  return (
    <>
      <ScrollToTopOnMount />
      <ImgHeader url="/static/img/Partnership.png" shadowOpacity={0.4}>
        <H1>Overview</H1>
      </ImgHeader>
      <WithHelperBar>
        {fromMarkdown("content/overview.md", 3)}
        <H2 notFirst>Steps</H2>
        <Steps path={getUrl("/content/steps.json")} />
        <H2 notFirst>Learn More</H2>
        <Grid container spacing={3}>
          <PartnershipTiersCard />
          <PartnershipBrandingCard />
          <IntegrationDefinitionCard />
          <MyIntegrationsCard />
          <ECommerceDocumentCard />
        </Grid>
      </WithHelperBar>
    </>
  );
};
